import $ from 'domtastic'
import EventBus from '../../EventBus.vue'

const COOKIE_NAME = 'dam_popup_skip'




/* DAM LINK BTN
----------------------------------------------------------------------------------------------------*/

export default class DamLinkBtn {

    constructor($el) {
        this.$el = $($el)

        this.clickHandler = (e) => { this.onClick(e) }

        this.bindEvents()
    }


    bindEvents() {
        this.$el.on('click', this.clickHandler)
    }




    /* Handlers
    --------------------------------------------------------- */

    onClick(e) {
        e.preventDefault()

        this.closeParentDropdown()

        const url = this.$el.attr('data-url')

        if (this.getCookie(COOKIE_NAME)) {
            window.open(url, '_blank', 'noopener')
            return
        }

        EventBus.$emit('dam-link-modal-open', { url })
    }


    closeParentDropdown() {
        const dropdown = this.$el[0].closest('.js-clickOutside.is-open')
        if (dropdown) {
            dropdown.querySelector('.js-hitarea').click()
        }
    }




    /* Values
    --------------------------------------------------------- */

    getCookie(name) {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
        return match ? match[2] : null
    }

}
